"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = __importDefault(require("lodash"));

var validator_1 = __importDefault(require("validator"));

var UtilsItem = __importStar(require("../utils/generic-item"));

var UtilsRow = __importStar(require("../utils/row"));

var UtilsLabel = __importStar(require("../utils/label"));

var item_filter_option_type_1 = __importDefault(require("../constants/item-filter-option-type"));

var column_type_1 = __importDefault(require("../constants/column-type"));

function globalSearch(list, query) {
  if (!query) {
    return list;
  }

  var lowerQuery = lodash_1.default.toLower(query);
  var result = [];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var item = _step.value;

      if (checkIfItemPassGlobalSearch(item, lowerQuery)) {
        result.push(item);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return result;
}

exports.globalSearch = globalSearch;

function checkIfItemPassGlobalSearch(item, query) {
  var title = item.title,
      subtitle = item.subtitle;
  title = lodash_1.default.toLower(title);
  subtitle = lodash_1.default.toLower(subtitle);

  if (lodash_1.default.isString(title) && title.indexOf(query) !== -1) {
    return true;
  }

  if (lodash_1.default.isString(subtitle) && subtitle.indexOf(query) !== -1) {
    return true;
  }

  var rows = UtilsItem.getRows(item);
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = rows[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var row = _step2.value;

      if (UtilsRow.checkIfPassGlobalSearch(row, query)) {
        return true;
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return false;
}

exports.checkIfItemPassGlobalSearch = checkIfItemPassGlobalSearch;

function compareItemMeta(meta1, meta2) {
  return lodash_1.default.isEqual(meta1, meta2);
}

exports.compareItemMeta = compareItemMeta;

function sortOptions(options) {
  return lodash_1.default.sortBy(options, [function (v) {
    return v.meta.label;
  }, function (v) {
    return v.meta.type;
  }]);
}

exports.sortOptions = sortOptions;

function sortOptionList(optionList, meta) {
  if (meta === null) {
    return optionList;
  }

  var cloned = lodash_1.default.clone(optionList);

  switch (meta.type) {
    case item_filter_option_type_1.default.NUMBER:
      {
        cloned.sort(function (a, b) {
          return a - b;
        });
        return cloned;
      }

    case item_filter_option_type_1.default.SHORT_TEXT:
    case item_filter_option_type_1.default.LONG:
      {
        cloned.sort(function (a, b) {
          if (a < b) {
            return -1;
          }

          if (a > b) {
            return 1;
          }

          return 0;
        });
        return cloned;
      }

    default:
      return cloned;
  }
}

exports.sortOptionList = sortOptionList;

function unionSelectedMetas(selected, userInputs) {
  var result = [];
  lodash_1.default.forEach(selected, function (u) {
    if (lodash_1.default.find(result, function (meta) {
      return lodash_1.default.isEqual(meta, u.meta);
    }) === undefined) {
      result.push(u.meta);
    }
  });
  lodash_1.default.forEach(userInputs, function (u) {
    if (lodash_1.default.find(result, function (meta) {
      return lodash_1.default.isEqual(meta, u.meta);
    }) === undefined) {
      result.push(u.meta);
    }
  });
  return result;
}

exports.unionSelectedMetas = unionSelectedMetas;

function groupSelectedAndUserInputByMeta(selecteds, userInputs) {
  var bundles = [];
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    var _loop = function _loop() {
      var selected = _step3.value;
      var meta = selected.meta;
      var foundBundle = lodash_1.default.find(bundles, function (u) {
        return lodash_1.default.isEqual(u.meta, meta);
      });

      if (!foundBundle) {
        bundles.push({
          selectedList: [selected],
          userInput: null,
          meta: meta
        });
      } else {
        foundBundle.selectedList = lodash_1.default.concat(foundBundle.selectedList, selected);
      }
    };

    for (var _iterator3 = selecteds[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      _loop();
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  var _iteratorNormalCompletion4 = true;
  var _didIteratorError4 = false;
  var _iteratorError4 = undefined;

  try {
    var _loop2 = function _loop2() {
      var userInput = _step4.value;
      var list = lodash_1.default.get(userInput, 'list', []);

      if (list.length === 0) {
        console.warn('userinput.length is 0');
        return "continue";
      }

      var meta = userInput.meta;
      var foundBundle = lodash_1.default.find(bundles, function (u) {
        return lodash_1.default.isEqual(u.meta, meta);
      });

      if (!foundBundle) {
        bundles.push({
          selectedList: [],
          userInput: userInput,
          meta: meta
        });
      } else {
        foundBundle.userInput = userInput;
      }
    };

    for (var _iterator4 = userInputs[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
      var _ret = _loop2();

      if (_ret === "continue") continue;
    }
  } catch (err) {
    _didIteratorError4 = true;
    _iteratorError4 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
        _iterator4.return();
      }
    } finally {
      if (_didIteratorError4) {
        throw _iteratorError4;
      }
    }
  }

  return bundles;
}

exports.groupSelectedAndUserInputByMeta = groupSelectedAndUserInputByMeta;

function filterBundlesByLabel(bundles, label) {
  return bundles.reduce(function (accu, bundle) {
    if (label === bundle.meta.label) {
      return lodash_1.default.concat(accu, bundle);
    } else {
      return accu;
    }
  }, []);
}

exports.filterBundlesByLabel = filterBundlesByLabel;

function filter(items, selected, userInputs) {
  if (selected.length === 0 && userInputs.length === 0) {
    return items;
  }

  var queryBundles = groupSelectedAndUserInputByMeta(selected, userInputs);
  return queryBundles.reduce(function (accu, bundle) {
    return filterByOneBundle(accu, bundle, items);
  }, lodash_1.default.clone(items));
}

exports.filter = filter;

function filterByOneBundle(items, bundle, refItems) {
  if (items.length === 0) {
    return items;
  }

  var result = [];
  var _iteratorNormalCompletion5 = true;
  var _didIteratorError5 = false;
  var _iteratorError5 = undefined;

  try {
    for (var _iterator5 = items[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
      var item = _step5.value;

      if (checkIfItemPassQueryBundle(item, bundle, refItems)) {
        result.push(item);
      }
    }
  } catch (err) {
    _didIteratorError5 = true;
    _iteratorError5 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
        _iterator5.return();
      }
    } finally {
      if (_didIteratorError5) {
        throw _iteratorError5;
      }
    }
  }

  return result;
}

exports.filterByOneBundle = filterByOneBundle;

function getFilterableColumns(row, meta) {
  var label = row.label,
      configs = row.configs;
  var is_filterable = lodash_1.default.get(row, 'configs.is_filterable', true);

  if (label === null || !is_filterable) {
    return [];
  }

  var labelText = UtilsLabel.getContent(label);

  if (!labelText) {
    return [];
  }

  if (meta.label !== labelText) {
    return [];
  }

  return UtilsRow.getColumns(row);
}

exports.getFilterableColumns = getFilterableColumns;

function checkIfItemPassQueryBundle(item, queryBundle, refItems) {
  var selectedList = queryBundle.selectedList,
      userInput = queryBundle.userInput,
      meta = queryBundle.meta;
  var hasOneMatch = false;
  var _iteratorNormalCompletion6 = true;
  var _didIteratorError6 = false;
  var _iteratorError6 = undefined;

  try {
    for (var _iterator6 = selectedList[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
      var selected = _step6.value;
      var must = selected.must;

      if (!!must || !hasOneMatch) {
        var result = checkIfItemPassSelected(item, selected, refItems);

        if (result) {
          hasOneMatch = true;
        } else {
          if (!!must) {
            return false;
          }
        }
      }
    }
  } catch (err) {
    _didIteratorError6 = true;
    _iteratorError6 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
        _iterator6.return();
      }
    } finally {
      if (_didIteratorError6) {
        throw _iteratorError6;
      }
    }
  }

  var userInputList = lodash_1.default.get(userInput, 'list', []);
  var _iteratorNormalCompletion7 = true;
  var _didIteratorError7 = false;
  var _iteratorError7 = undefined;

  try {
    for (var _iterator7 = userInputList[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
      var userInputRow = _step7.value;
      var must = userInputRow.must;

      if (!!must || !hasOneMatch) {
        var _result = checkIfItemPassUserInput(item, userInputRow, meta, refItems);

        if (_result) {
          hasOneMatch = true;
        } else {
          if (!!must) {
            return false;
          }
        }
      }
    }
  } catch (err) {
    _didIteratorError7 = true;
    _iteratorError7 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
        _iterator7.return();
      }
    } finally {
      if (_didIteratorError7) {
        throw _iteratorError7;
      }
    }
  }

  if (selectedList.length === 0 && userInputList.length === 0) {
    return true;
  } else {
    return hasOneMatch;
  }
}

function checkIfItemPassSelected(item, selected, refItems) {
  var hasOneMatch = false;
  var meta = selected.meta;
  var rows = UtilsItem.getRows(item);
  var _iteratorNormalCompletion8 = true;
  var _didIteratorError8 = false;
  var _iteratorError8 = undefined;

  try {
    for (var _iterator8 = rows[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
      var row = _step8.value;
      var columns = getFilterableColumns(row, meta);
      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = columns[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var column = _step9.value;
          var checkResult = checkColumnPassSelected(column, selected, refItems);

          if (checkResult === 1) {
            hasOneMatch = true;
          }
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return != null) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }
    }
  } catch (err) {
    _didIteratorError8 = true;
    _iteratorError8 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion8 && _iterator8.return != null) {
        _iterator8.return();
      }
    } finally {
      if (_didIteratorError8) {
        throw _iteratorError8;
      }
    }
  }

  return hasOneMatch;
}

function checkIfItemPassUserInput(item, userInputRow, meta, refItems) {
  if (userInputRow === null) {
    return false;
  }

  var rows = UtilsItem.getRows(item);
  var hasOneMatch = false;
  var _iteratorNormalCompletion10 = true;
  var _didIteratorError10 = false;
  var _iteratorError10 = undefined;

  try {
    for (var _iterator10 = rows[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
      var row = _step10.value;
      var columns = getFilterableColumns(row, meta);
      var _iteratorNormalCompletion11 = true;
      var _didIteratorError11 = false;
      var _iteratorError11 = undefined;

      try {
        for (var _iterator11 = columns[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
          var column = _step11.value;
          var checkResult = checkColumnPassUserInputRow(column, userInputRow, meta, refItems);

          if (checkResult === 1) {
            hasOneMatch = true;
          }
        }
      } catch (err) {
        _didIteratorError11 = true;
        _iteratorError11 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion11 && _iterator11.return != null) {
            _iterator11.return();
          }
        } finally {
          if (_didIteratorError11) {
            throw _iteratorError11;
          }
        }
      }
    }
  } catch (err) {
    _didIteratorError10 = true;
    _iteratorError10 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion10 && _iterator10.return != null) {
        _iterator10.return();
      }
    } finally {
      if (_didIteratorError10) {
        throw _iteratorError10;
      }
    }
  }

  return hasOneMatch;
}

function checkColumnPassSelected(column, selected, refItems) {
  var meta = selected.meta;
  var type = column.type;

  switch (meta.type) {
    case item_filter_option_type_1.default.BOOLEAN:
      {
        if (type === column_type_1.default.BOOLEAN) {
          var compare = selected.compare;
          var input = column.input;

          if (compare.on && input || !compare.on && !input) {
            return 1;
          } else {
            return -1;
          }
        }

        break;
      }

    case item_filter_option_type_1.default.SHORT_TEXT:
      {
        if (type === column_type_1.default.SHORT) {
          var _compare = selected.compare;
          var option = selected.option;
          var _input = column.input;

          if (_compare.equal) {
            if (_input === option) {
              return 1;
            } else {
              return -1;
            }
          }
        }

        break;
      }

    case item_filter_option_type_1.default.LONG:
      {
        console.warn("Long column is being filtered in selected list, which is unexpected");
        return 0;
      }

    case item_filter_option_type_1.default.NUMBER:
      {
        if (type === column_type_1.default.NUMBER) {
          var _compare2 = selected.compare;
          var _option = selected.option;
          var _input2 = column.input;
          var equal = _compare2.equal,
              larger = _compare2.larger,
              smaller = _compare2.smaller;

          if (equal) {
            if (larger) {
              if (_input2 >= _option) {
                return 1;
              } else {
                return -1;
              }
            } else if (smaller) {
              if (_input2 <= _option) {
                return 1;
              } else {
                return -1;
              }
            } else {
              if (_input2 === _option) {
                return 1;
              } else {
                return -1;
              }
            }
          } else {
            if (larger && _input2 > _option || smaller && _input2 < _option) {
              return 1;
            } else {
              return -1;
            }
          }
        }

        break;
      }

    case item_filter_option_type_1.default.RELATION:
      {
        if (type === column_type_1.default.RELATION) {
          var _compare3 = selected.compare;
          var _option2 = selected.option;
          var _input3 = column.input;

          if (_compare3.equal && lodash_1.default.isEqual(_option2, _input3)) {
            return 1;
          } else {
            return -1;
          }
        }

        break;
      }

    default:
      return 0;
  }

  return 0;
}

function checkColumnPassUserInputRow(column, userInputRow, meta, items) {
  var type = column.type;

  switch (meta.type) {
    case item_filter_option_type_1.default.NUMBER:
      {
        if (type === column_type_1.default.NUMBER) {
          var option = userInputRow.option,
              compare = userInputRow.compare;
          var input = column.input;
          var equal = compare.equal,
              larger = compare.larger,
              smaller = compare.smaller;

          if (equal) {
            if (larger) {
              if (input >= option) {
                return 1;
              } else {
                return -1;
              }
            } else if (smaller) {
              if (input <= option) {
                return 1;
              } else {
                return -1;
              }
            } else {
              if (input === option) {
                return 1;
              } else {
                return -1;
              }
            }
          } else {
            if (larger && input > option || smaller && input < option) {
              return 1;
            } else {
              return -1;
            }
          }
        }

        break;
      }

    case item_filter_option_type_1.default.RATE:
      {
        if (type === column_type_1.default.RATE) {
          var _option3 = userInputRow.option,
              _compare4 = userInputRow.compare;
          var value = lodash_1.default.get(column, 'input.value', null);

          if (value !== null && lodash_1.default.isFinite(value)) {
            var _equal = _compare4.equal,
                _larger = _compare4.larger,
                _smaller = _compare4.smaller;

            if (_equal) {
              if (_larger) {
                if (value >= _option3) {
                  return 1;
                } else {
                  return -1;
                }
              } else if (_smaller) {
                if (value <= _option3) {
                  return 1;
                } else {
                  return -1;
                }
              } else {
                if (value === _option3) {
                  return 1;
                } else {
                  return -1;
                }
              }
            } else {
              if (_larger && value > _option3 || _smaller && value < _option3) {
                return 1;
              } else {
                return -1;
              }
            }
          }
        }

        break;
      }

    case item_filter_option_type_1.default.SHORT_TEXT:
      {
        if (type === column_type_1.default.SHORT) {
          var _option4 = userInputRow.option,
              _compare5 = userInputRow.compare;
          var _input4 = column.input;

          if (_compare5.include && _input4.includes(_option4)) {
            return 1;
          } else {
            return -1;
          }
        }

        break;
      }

    case item_filter_option_type_1.default.LONG:
      {
        if (type === column_type_1.default.LONG) {
          var _option5 = userInputRow.option,
              _compare6 = userInputRow.compare;
          var _input5 = column.input;

          if (_compare6.include && _input5.includes(_option5)) {
            return 1;
          } else {
            return -1;
          }
        }

        break;
      }

    case item_filter_option_type_1.default.RELATION:
      {
        if (type === column_type_1.default.RELATION) {
          var _option6 = userInputRow.option,
              _compare7 = userInputRow.compare,
              userInputRowLabel = userInputRow.label;
          var _column$input = column.input,
              target_id = _column$input.target_id,
              target_type = _column$input.target_type;
          var relatedItem = lodash_1.default.find(items, {
            id: target_id
          });

          if (relatedItem) {
            var rows = relatedItem.rows;
            var _iteratorNormalCompletion12 = true;
            var _didIteratorError12 = false;
            var _iteratorError12 = undefined;

            try {
              for (var _iterator12 = rows[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
                var row = _step12.value;
                var rowLabel = row.label;

                if (rowLabel) {
                  var targetItemRowLabel = rowLabel.content;

                  if (targetItemRowLabel === userInputRowLabel) {
                    var columns = row.content.columns;
                    var _iteratorNormalCompletion13 = true;
                    var _didIteratorError13 = false;
                    var _iteratorError13 = undefined;

                    try {
                      for (var _iterator13 = columns[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
                        var _column = _step13.value;

                        switch (_column.type) {
                          case column_type_1.default.SHORT:
                          case column_type_1.default.LONG:
                            {
                              var columnInput = _column.input;

                              if (_compare7.equal && columnInput === _option6) {
                                return 1;
                              } else {
                                return -1;
                              }

                              if (_compare7.include && _option6 !== null && columnInput.includes(_option6)) {
                                return 1;
                              } else {
                                return -1;
                              }

                              break;
                            }

                          case column_type_1.default.BOOLEAN:
                            {
                              var _columnInput = _column.input;

                              if (_compare7.on === 0 && !_columnInput) {
                                return 1;
                              }

                              if (_compare7.on === 1 && _columnInput) {
                                return 1;
                              }

                              break;
                            }

                          case column_type_1.default.NUMBER:
                            {
                              var _columnInput2 = _column.input;

                              if (lodash_1.default.isString(_option6) && validator_1.default.isNumeric(_option6)) {
                                var parsedOption = lodash_1.default.toNumber(_option6);

                                if (_compare7.equal) {
                                  if (_compare7.larger) {
                                    if (_columnInput2 >= parsedOption) {
                                      return 1;
                                    } else {
                                      return -1;
                                    }
                                  } else {
                                    if (_columnInput2 === parsedOption) {
                                      return 1;
                                    } else {
                                      return -1;
                                    }
                                  }

                                  if (_compare7.smaller) {
                                    if (_columnInput2 <= parsedOption) {
                                      return 1;
                                    } else {
                                      return -1;
                                    }
                                  } else {
                                    if (_columnInput2 === parsedOption) {
                                      return 1;
                                    } else {
                                      return -1;
                                    }
                                  }
                                } else if (_compare7.larger) {
                                  if (_columnInput2 > parsedOption) {
                                    return 1;
                                  } else {
                                    return -1;
                                  }
                                } else if (_compare7.smaller) {
                                  if (_columnInput2 < parsedOption) {
                                    return 1;
                                  } else {
                                    return -1;
                                  }
                                }
                              }

                              break;
                            }

                          case column_type_1.default.RATE:
                            {
                              var _columnInput3 = lodash_1.default.get(_column, 'input.value', null);

                              if (_columnInput3 !== null && lodash_1.default.isFinite(_columnInput3)) {
                                var _parsedOption = lodash_1.default.toNumber(_option6);

                                var _equal2 = _compare7.equal,
                                    _larger2 = _compare7.larger,
                                    _smaller2 = _compare7.smaller;

                                if (_equal2) {
                                  if (_larger2) {
                                    if (_columnInput3 >= _parsedOption) {
                                      return 1;
                                    } else {
                                      return -1;
                                    }
                                  } else if (_smaller2) {
                                    if (_columnInput3 <= _parsedOption) {
                                      return 1;
                                    } else {
                                      return -1;
                                    }
                                  } else {
                                    if (_columnInput3 === _parsedOption) {
                                      return 1;
                                    } else {
                                      return -1;
                                    }
                                  }
                                } else {
                                  if (_larger2 && _columnInput3 > _parsedOption || _smaller2 && _columnInput3 < _parsedOption) {
                                    return 1;
                                  } else {
                                    return -1;
                                  }
                                }
                              }

                              break;
                            }
                        }
                      }
                    } catch (err) {
                      _didIteratorError13 = true;
                      _iteratorError13 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion13 && _iterator13.return != null) {
                          _iterator13.return();
                        }
                      } finally {
                        if (_didIteratorError13) {
                          throw _iteratorError13;
                        }
                      }
                    }
                  }
                }
              }
            } catch (err) {
              _didIteratorError12 = true;
              _iteratorError12 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion12 && _iterator12.return != null) {
                  _iterator12.return();
                }
              } finally {
                if (_didIteratorError12) {
                  throw _iteratorError12;
                }
              }
            }
          }
        }

        break;
      }

    default:
      {
        return 0;
      }
  }

  return 0;
}

function mergeOptionFromRows(fromRows) {
  var groups = fromRows.reduce(function (acc, cur) {
    var found = lodash_1.default.find(acc, {
      meta: cur.meta
    });

    if (!found) {
      return lodash_1.default.concat(acc, {
        meta: cur.meta,
        list: cur.input === null ? [] : [cur.input]
      });
    }

    found.list = lodash_1.default.concat(found.list, cur.input);
    return acc;
  }, []);
  var _iteratorNormalCompletion14 = true;
  var _didIteratorError14 = false;
  var _iteratorError14 = undefined;

  try {
    for (var _iterator14 = groups[Symbol.iterator](), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
      var group = _step14.value;
      group.list = lodash_1.default.uniqWith(group.list, lodash_1.default.isEqual);
    }
  } catch (err) {
    _didIteratorError14 = true;
    _iteratorError14 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion14 && _iterator14.return != null) {
        _iterator14.return();
      }
    } finally {
      if (_didIteratorError14) {
        throw _iteratorError14;
      }
    }
  }

  return groups;
}

exports.mergeOptionFromRows = mergeOptionFromRows;

function pickOptionGroups(groups, selected) {
  return lodash_1.default.filter(groups, function (group) {
    return !!lodash_1.default.find(selected, {
      row_title: group.meta.label,
      column_title: group.meta.column_title || null
    });
  });
}

exports.pickOptionGroups = pickOptionGroups;